import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Axios from "axios";
import Cookies from "universal-cookie";
import uuid from "react-uuid";
import Container from "../components-layout/Container";
import Layout from "../Layout";
import WarningModal from "../components-modals/WarningModal";
import DatagridItemsBodega from "./bodegas/DatagridItemsBodega";
import Pagination from "../components-contabilidad-analisis/Pagination";
import ResumenProductos from "./bodegas/ResumenProductos";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/outline";
import FacturacionForm from "./facturacion/FacturacionForm";
import SubmitButton from "./facturacion/SubmitButton";
import Pago from "./facturacion/Pago";
import { Form, Formik } from "formik";
import { object, string, number } from "yup";
import Header from "../components-layout/Header";
import { DocumentPlusIcon } from "@heroicons/react/24/outline";
import BusquedaAlumnosModal from "./BusquedaAlumnosModal";
import { retrieveData } from "../../helpers/helpers";
import OtherWarehousesModal from "./facturacion/OtherWarehousesModal";

const searchParams = [
  "IdProducto",
  "Descripcion",
  "Descripcion_Corta",
  "Imagen",
  "IdTipo",
  "Tipo",
  "IdCategoria",
  "Categoria",
  "IdProveedor",
  "Proveedor",
  "Costo",
  "Precio",
  "Existencia",
  "Inventario",
  "FacRapida",
  "Pedido",
  "Activo",
];
let runInit = true;

const Facturacion = () => {
  const user = useSelector((state) => state.auth.user);
  const userObj = JSON.parse(user);

  const cookies = new Cookies();
  const urlInvoiceApi = cookies.get("__urlInvoiceApi");
  const url = urlInvoiceApi + "/utils/busquedas";
  const headers = useSelector((state) => state.url.headersAPI);

  //Fetch inicial de productos
  const [loading, setLoading] = useState(true);
  const [rawData, setRawData] = useState([]);
  const [enableVoucher, setEnableVoucher] = useState(false);

  const bodegas = useSelector((state) => state.auth.bodegas);
  const primerIdBodega = bodegas[0].IdBodega;
  useEffect(() => {
    const fetchData = async () => {
      //setLoading(true);
      try {
        const res = await Axios({
          method: "GET",
          url,
          headers,
          params: {
            opcion: "PRODUCTOS",
            IdBodega: primerIdBodega,
          },
        });

        setRawData(res.data);
        if (res.data.length > 0) setEnableVoucher(res.data[0].Voucher);

        setLoading(false);
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, []);

  //Busqueda
  const [filterData, setFilter] = useState([]);
  useEffect(() => {
    setFilter(rawData);
  }, [rawData]);

  const [query, setQuery] = useState("");
  const handleQuery = (e, query) => {
    e.preventDefault();
    doSearch(query.trim());
    setCurrentPage(1);
  };

  const doSearch = (query) => {
    if (query === null) {
      setFilter(rawData);
    } else {
      setFilter(
        rawData.filter((x) => {
          return searchParams.some((y) => {
            return (
              x[y]?.toString().toLowerCase().indexOf(query.toLowerCase()) > -1
            );
          });
        })
      );
    }
  };
  //Fin busqueda

  //Paginación Productos
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  const currentRecords = filterData?.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const nPages = Math.ceil(filterData?.length / recordsPerPage);
  //Fin paginación Productos

  //Helpers de productos tipo CRUD
  const [productos, setProducto] = useState([]);
  const [otherWarehouses, setOtherWarehouses] = useState([]);
  const [showOtherWarehousesModal, setShowOtherWarehousesModal] =
    useState(false);

  const addProduct = async (producto) => {
    try {
      let {
        Existencia,
        Unidades,
        Unidad = 1,
        IdProducto,
        Inventario,
      } = producto;

      if (Existencia < 1 && Inventario) {
        const res = await retrieveData({
          url,
          headers,
          method: "GET",
          payload: {
            opcion: "PRODUCTOSGRAL",
            IdProducto,
          },
        });

        const otherWarehousesWithProductArr = res;
        if (otherWarehousesWithProductArr.length === 0) {
          throw new Error("Sin existencias en todas las bodegas");
        }

        setOtherWarehouses(otherWarehousesWithProductArr);
        return setShowOtherWarehousesModal(true);
      }

      if (Unidades) {
        Unidad = Unidades[0].Unidad;
      }

      const isDuplicated =
        productos.findIndex(
          (prod) => prod.IdProducto === producto.IdProducto
        ) !== -1
          ? true
          : false;

      if (!isDuplicated) {
        const id = uuid();

        setProducto((curr) => [...curr, { ...producto, id, qty: 1, Unidad }]);
      }
    } catch (err) {
      console.log(err);
      return setModal({
        msg: "Producto sin existencias",
        ok: false,
        show: true,
      });
    }
  };

  const updateProducto = (producto, prop = "", payload = "") => {
    const { id, Existencia } = producto;

    const indexOfId = productos.findIndex((producto) => producto.id === id);

    if (prop === "qty" || prop === "Unidad") {
      return setProducto((curr) => {
        if (payload >= 0 && payload <= Existencia) {
          curr[indexOfId][prop] = payload;
        }
        return [...curr];
      });
    }

    if (prop === "Descripcion" || prop === "Precio") {
      return setProducto((curr) => {
        curr[indexOfId][prop] = payload;

        return [...curr];
      });
    }
  };

  const delProducto = (producto) => {
    const { id } = producto;

    const newProductos = productos.filter((prod) => prod.id !== id);
    setProducto(newProductos);
  };

  //Manejo de errores
  const [modal, setModal] = useState({
    show: false,
    msg: "",
    ok: false,
  });

  //Formateo de values y POST

  const fetchData = async (data) => {
    setLoading(true);
    try {
      const res = await Axios({
        method: "POST",
        url: urlInvoiceApi + "/inventario/facturas",
        headers,
        data,
      });

      const { Error: err } = res.data.msg;

      if (err !== 0) {
        throw new Error("ERR_CYBERSOURCE");
      }

      setLoading(false);

      setModal({
        msg: "Transacción realizada con exito!",
        ok: true,
        show: true,
        reload: true,
      });
    } catch (err) {
      setLoading(false);
      const msg =
        err.message !== "ERR_CYBERSOURCE"
          ? "Transacción en proceso, puede revisar en unos minutos"
          : "Transacción denegada, revise sus datos.";

      setModal({
        ok: false,
        msg: msg,
        show: true,
        reload: true,
      });

      console.log(err);
    }
  };

  const IdEmp = useSelector((state) => state.auth.IdEmp);
  const handleSubmit = (values) => {
    if (/\d{7}/.test(values.Cel)) {
      console.log("VALUES: ", values);

      const d = new Date().toLocaleDateString("es-GT");
      const fecha = d
        .split("/")
        .reverse()
        .map((x) => x.padStart(2, "0"))
        .join("");

      let {
        mmyy,
        efectivo,
        tarjeta,
        noBoleta,
        fechaBoleta,
        monto,
        Nit,
        Direccion,
        ...resto
      } = values;
      let voucher = enableVoucher ? values.voucher : null;
      let [mes, year] = mmyy.split("/");
      year = year ? "20" + year : "";

      //IdBodega = IdBodega === '' ? primerIdBodega : IdBodega;
      //Revisar que el movimiento de bodega no este vacio
      if (productos.length === 0) {
        return setModal({
          msg: "Seleccione al menos un producto",
          ok: false,
          show: true,
        });
      }

      //Revisar si todos los productos llevan cantidad valida
      if (productos.some((producto) => producto.qty === 0)) {
        return setModal({
          msg: "Ingrese la cantidad en todos los productos",
          ok: false,
          show: true,
        });
      }

      if (monto >= 2500 && Nit === "CF") {
        return setModal({
          msg: "Para montos mayores a Q2500.00 no se puede facturar con CF.",
          ok: false,
          show: true,
        });
      }

      //Revisar subtotal
      const subtotal = enableVoucher
        ? Number(efectivo) + Number(tarjeta) + Number(voucher)
        : Number(efectivo) + Number(tarjeta);

      if (monto !== subtotal) {
        return setModal({
          msg: "Revisar formas de pago. Subtotal no coincide con total.",
          ok: false,
          show: true,
        });
      }

      //Formateo de formas de pago
      const FormasPago = fomatearFormasPago(
        efectivo,
        tarjeta,
        fecha,
        voucher,
        noBoleta,
        fechaBoleta
      );

      //Formateo de productos seleccionados
      const DetalleProductos = productos.map(
        ({
          IdBodega,
          IdProducto,
          qty,
          Unidad,
          Descripcion,
          Precio,
          Consignacion,
        }) => ({
          Descripcion,
          Precio,
          Consignacion: Consignacion ? 1 : 0,
          IdProducto,
          IdBodega: !IdBodega ? values.IdBodega : IdBodega,
          Cantidad: qty,
          Unidad,
        })
      );

      const data = JSON.stringify({
        ...resto,
        Nit,
        Direccion: Direccion.length > 200 ? Direccion.slice(0, 200) : Direccion,
        monto,
        mes,
        year,
        Canal: 4,
        FormasPago,
        DetalleProductos,
        IdEmp,
        HostName: "DEV07",
        IpHost: "131.107.1.235",
        OS: "Windows",
      });

      fetchData(data);
    }else{
        setModal({
            ok: false,
            msg: 'Número de celular inválido',
            show: true,
        })
    }
  };

  //Estado que maneja componente de busqueda de alumno (modal)
  const [showSearchModal, setShowSearchModal] = useState(false);

  return (
    <Layout userObj={userObj} activeTab="Facturación">
      <WarningModal
        open={loading ? true : false}
        image={<img src="./img/loader.gif" alt="loading" />}
        opacity="bg-opacity-100"
      />

      <WarningModal
        open={modal.show ? true : false}
        image={
          modal.ok ? (
            <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
          ) : (
            <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
          )
        }
        title="Aviso"
        subtitle={<span>{modal.msg}</span>}
        opacity="bg-opacity-50"
      >
        <div className="mt-5 sm:mt-6">
          <button
            onClick={() => {
              if (modal.reload) {
                window.location.reload();
              }
              setModal((curr) => ({
                ...curr,
                show: false,
                reload: false,
              }));
            }}
            type="button"
            className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
          >
            Entendido
          </button>
        </div>
      </WarningModal>

      <OtherWarehousesModal
        setShowForm={setShowOtherWarehousesModal}
        showForm={showOtherWarehousesModal}
        data={otherWarehouses}
        url={urlInvoiceApi}
        headers={headers}
        addProduct={addProduct}
      />

      <Container height="h-full">
        <Formik
          initialValues={{
            //Campos de la factura
            Carnet: "",
            Alumno: "",
            IdBodega: primerIdBodega,
            Nit: "",
            NombreDoc: "",
            Direccion: "",
            Cel: "",
            Email: "",
            //Campos solo necesarios si se cancela con tarjeta de crédito
            number: "",
            mmyy: "",
            code: "",
            nombres: "",
            apellidos: "",
            direccion: "",
            pais: "",
            email: "",
            //Campos solo necesarios si se cancela con voucher
            noBoleta: "",
            fechaBoleta: "",
            //Campo requeridos para realizar pago
            monto: "",
            efectivo: 0,
            tarjeta: 0,
            voucher: 0,
          }}
          validationSchema={object({
            Nit: string().required("Dato obligatorio."),
            NombreDoc: string().when("Nit", {
              is: "CF",
              then: (schema) => schema,
              otherwise: (schema) => schema.required("Dato obligatorio"),
            }),
            Cel: string().required("Dato obligatorio."),
            Email: string().required("Dato obligatorio."),
            Direccion: string().required("Dato obligatorio."),
            efectivo: number().required("Dato obligatorio."),
            tarjeta: number().required("Dato obligatorio."),
          })}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, resetForm, errors, touched }) => {
            return (
              <Form>
                <BusquedaAlumnosModal
                  setShowForm={setShowSearchModal}
                  showForm={showSearchModal}
                  url={url}
                  headers={headers}
                  setModal={setModal}
                  setFieldValue={setFieldValue}
                  values={values}
                />
                <Header title="Generar Factura" logo={DocumentPlusIcon} />
                <div className="grid grid-cols-1 2xl:grid-cols-2 gap-5 2xl:gap-x-5 2xl:gap-y-0">
                  <div className="order-1 bg-primarioMira shadow-2xl rounded-lg 2xl:rounded-b-none 2xl:rounded-t-lg border-b-0 2xl:border-b border-b-grisMira">
                    <FacturacionForm
                      url={urlInvoiceApi}
                      headers={headers}
                      setModal={setModal}
                      values={values}
                      setFieldValue={setFieldValue}
                      resetForm={resetForm}
                      setRawData={setRawData}
                      setEnableVoucher={setEnableVoucher}
                      setLoading={setLoading}
                      setShowSearchModal={setShowSearchModal}
                    />
                  </div>
                  <div className="order-2 2xl:order-3 bg-primarioMira shadow-2xl rounded-lg 2xl:rounded-t-none 2xl:rounded-b-lg">
                    <DatagridItemsBodega
                      data={currentRecords}
                      handleQuery={handleQuery}
                      addProduct={addProduct}
                      isFormik={false}
                      query={query}
                      setQuery={setQuery}
                      label="Lista detallada de productos donde puede consultar y agregar productos a la factura."
                    />
                    <Pagination
                      nPages={nPages}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      totalRecords={filterData?.length}
                      indexOfFirstRecord={indexOfFirstRecord}
                      indexOfLastRecord={indexOfLastRecord}
                    />
                  </div>
                  <div className="order-3 2xl:order-2 bg-primarioMira shadow-2xl rounded-lg 2xl:rounded-b-none 2xl:rounded-t-lg border-b-0 2xl:border-b border-b-grisMira">
                    <ResumenProductos
                      productos={productos}
                      delProducto={delProducto}
                      updateProducto={updateProducto}
                      height={"2xl:h-[15rem]"}
                    />
                  </div>

                  <div className="order-last bg-primarioMira shadow-2xl rounded-lg 2xl:rounded-t-none 2xl:rounded-b-lg">
                    <Pago
                      values={values}
                      setFieldValue={setFieldValue}
                      productos={productos}
                      setModal={setModal}
                      errors={errors}
                      touched={touched}
                      enableVoucher={enableVoucher}
                    />
                    <SubmitButton label={"Realizar factura"} />
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Container>
    </Layout>
  );
};

const fomatearFormasPago = (
  efectivo,
  tarjeta,
  fecha,
  voucher,
  noBoleta,
  fechaBoleta
) => {
  let array = [];

  array[0] = {
    TipoTrans: 1,
    NoBoleta: "",
    IdBanco: 0,
    Valor: efectivo,
    Fecha: fecha,
  };

  array[1] = {
    TipoTrans: 8,
    NoBoleta: "",
    IdBanco: 0,
    Valor: tarjeta,
    Fecha: fecha,
  };

  if (voucher) {
    array[2] = {
      TipoTrans: 4,
      NoBoleta: noBoleta,
      IdBanco: 0,
      Valor: voucher,
      Fecha: fechaBoleta,
    };
  }

  return array;
};

export default Facturacion;
